import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Form,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap";
import PaymentState from "Hooks/Payment.state";
import "./payment.css";
import { Button, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { UserContext } from "Hooks/UserContext";
import {Chip} from "@mui/material";
import { useNavigate } from "react-router-dom";
const PaymentComponent = () => {
  const [selectedOption, setSelectedOption] = useState(0);
  const [accountData, setAccountData] = useState({});
  const [modal, setModal] = useState(false);
  const [deletemodal, setDeleteModal] = useState(false);
  const { user, value, setValue } = useContext(UserContext)
  const navigate = useNavigate()




  const {
    saveAccountInfo,
    formBusy,
    accountResult,
    getAccountInfo,
    account,
    updateAccountInfo,
  } = PaymentState();

  function toggleTab(tab) {
    if (selectedOption !== tab) {
      setSelectedOption(tab)
    }
  }



  useEffect(() => {
    getAccountInfo();
  }, [accountResult]);

  useEffect(() => {
    if (account !== null) {
      sessionStorage.setItem("account", JSON.stringify(account));
      setAccountData(account);
    } else {
      sessionStorage.setItem("account", null);
    }
  }, [account]);

  const formatDate = (date) => {
    const d = new Date(date);
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yy = d.getFullYear();
    return `${m}-${dd}-${yy}`;
  };

const chipSX = {
    height: 24,
    padding: '0 6px'
  };
  
  const chipSuccessSX = {
        ...chipSX,
        color:"#074521",
        backgroundColor: "#6ed398",
        height: 28,
        borderRadius: 5
      };


  return (
    <div className="page-content" style={{height:window.innerWidth<768 && (selectedOption===0||selectedOption===1)?"100%":"100%"}} >
      <Container fluid>
        <Row>
          <Col xl="12">
            <Card>
              {selectedOption===0&&(
              <IconButton onClick={() => setValue(0)} sx={{ backgroundColor: "#92c323", m: 2, px: 3, color: "#FFF", width: "fit-content", borderRadius: 2, '&:hover': { backgroundColor: "#76a521" } }} variant="contained" size="icon" className="d-flex d-md-none"   >
                <FontAwesomeIcon icon={faChevronLeft} />
              </IconButton>
              )}
              <CardBody className="p-4" >

                <Form>
                  {/* Radio buttons to switch view */}
                  {selectedOption === 0 && (
                    <Row className="g-2 g-md-4">
                      <Col sm={12} md={12} lg={6} xl={5} >
                        <div>
                          <div className="form-check card-radio" onClick={() => toggleTab(1)} >
                            <Input
                              id="paymentMethod01"
                              name="paymentMethod"
                              type="radio"
                              className="form-check-input"
                              checked={selectedOption === 1}
                              onChange={() => {
                                toggleTab(1)
                              }}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="paymentMethod01"
                            >
                              <div className="d-flex  align-items-center " >
                              <span className="fs-15  me-2 ">
                                <div style={{border:"solid 2px ",borderRadius:"50%",height:60,width:60}} className="p-2 d-flex justify-content-center align-items-center "  >
                                <i style={{fontSize:27}} className="ri-bank-line  align-bottom"></i>
                                </div>
                              </span>
                              <span className=" fs-15 text-wrap">{" "}
                                <div style={{fontSize:19}} >Bank Account</div>
                               
                              </span>
                              </div>
                            </Label>
                          </div>
                        </div>
                      </Col>
                      <Col sm={12} md={12} lg={6} xl={5} >
                        <div>
                          <div className="form-check card-radio" onClick={() => toggleTab(3)}>
                            <Input
                              id="paymentMethod02"
                              name="paymentMethod"
                              type="radio"
                              className="form-check-input"
                              checked={selectedOption === 2}
                              onChange={() => {
                                toggleTab(3);
                              }}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="paymentMethod02"
                            >
                                <div className="d-flex  align-items-center " >
                              <span className="fs-15  me-2 ">
                                <div style={{border:"solid 2px ",borderRadius:"50%",height:60,width:60}} className="p-2 d-flex justify-content-center align-items-center "  >
                                <i style={{fontSize:27}} className="ri-bank-card-fill align-bottom"></i>
                                </div>
                              </span>
                              <span className=" fs-15 text-wrap">{" "}
                                <div style={{fontSize:19}} > Credit / Debit Card</div>
                               
                              </span>
                              </div>
                            
                            </Label>
                          </div>
                        </div>
                      </Col>


                    </Row>
                  )}
                   {selectedOption === 1 && (
                    <>
                     <IconButton onClick={() => toggleTab(0)} sx={{ backgroundColor: "#92c323", mt: -1,ml:-1, px: 3, color: "#FFF", width: "fit-content", borderRadius: 2, '&:hover': { backgroundColor: "#76a521" } }} variant="contained" size="icon" className=""   >
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </IconButton>
                    
                    <Row className="g-2 g-md-4">
                      
                      <Col sm={12} md={12} lg={6} xl={5} >
                        <div>
                          <div className="form-check card-radio" onClick={() => toggleTab(1)} >
                            <Input
                              id="paymentMethod01"
                              name="paymentMethod"
                              type="radio"
                              className="form-check-input"
                              checked={selectedOption === 2}
                              // onChange={() => {
                              //   toggleTab(2)
                              // }}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="paymentMethod01"
                            >
                              <div className="d-flex  " >
                              <span className="fs-15  me-2 pt-3 ">
                                <div style={{border:"solid 2px ",borderRadius:"50%",height:60,width:60}} className="p-2 d-flex justify-content-center align-items-center "  >
                                <i style={{fontSize:27}} className="ri-bank-line  align-bottom"></i>
                                </div>
                              </span>
                              <span className=" fs-15 text-wrap">{" "}
                                <div style={{fontSize:19}} >{accountData?.bank_name}</div>
                                <div style={{fontSize:14}} >{accountData?.account_number} (Account Number)</div>
                                <div style={{fontSize:14}} className="mb-2" >{accountData?.routing_number} (Routing Number)</div>
                                <Chip mt={2} sx={chipSuccessSX} label="Active" />
                              </span>
                              </div>
                            </Label>
                          </div>
                        </div>
                      </Col>
                      <Col sm={12} md={12} lg={6} xl={5} >
                        <div>
                          <div className="form-check card-radio" >
                            <Input
                              id="paymentMethod02"
                              name="paymentMethod"
                              type="radio"
                              className="form-check-input"
                              checked={selectedOption === 3}
                              onChange={() => {
                               
                              }}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="paymentMethod02"
                            >
                              <div className="d-flex align-items-center " >
                              <span className="fs-15  me-2  ">
                                <div style={{border:"solid 2px ",borderRadius:"50%",height:60,width:60}} className="p-2 d-flex justify-content-center align-items-center "  >
                                <i style={{fontSize:27}} className="ri-article-line  align-bottom"></i>
                                </div>
                              </span>
                              <span className=" fs-15 text-wrap">{" "}
                                <div style={{fontSize:19}} >Invoice</div>
                                <div style={{fontSize:14}} >View Invoice</div>
                               
                              </span>
                              </div>
                            </Label>
                          </div>
                        </div>
                      </Col>


                    </Row>
                    </>
                  )}

                  {/* Bank Account View */}
                  {selectedOption === 2 && (
                    <>
                      <IconButton onClick={() => toggleTab(1)} sx={{ backgroundColor: "#92c323", m: 0, px: 3, color: "#FFF", width: "fit-content", borderRadius: 2, '&:hover': { backgroundColor: "#76a521" } }} variant="contained" size="icon" className=""   >
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </IconButton>

                       <div className="d-flex mt-3 " >
                              <span className="fs-15  me-2 pt-3 ">
                                <div style={{border:"solid 2px ",borderRadius:"50%",height:60,width:60}} className="p-2 d-flex justify-content-center align-items-center "  >
                                <i style={{fontSize:27}} className="ri-bank-line  align-bottom"></i>
                                </div>
                              </span>
                              <span className=" fs-15 text-wrap">{" "}
                                <div style={{fontSize:19}} >Bank Name</div>
                                <div style={{fontSize:14}} >{accountData?.account_number} (Account NO)</div>
                                <div style={{fontSize:14}} className="mb-2" >{accountData?.routing_number} (Routing NO)</div>
                                <Chip mt={2} sx={chipSuccessSX} label="Active" />
                              </span>
                              </div>
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center " >
                        {/* <h5 className="mb-1 mt-4"> Bank Account</h5> */}
                       
                      </div>
                      <Card className="p-0 p-lg-5 border shadow-none mb-0 mt-4">
                        {Object.keys(accountData).length === 0 ? (
                          <div className="text-center">
                            <i
                              className="ri-bank-line"
                              style={{ fontSize: "10rem", color: "gray" }}
                            ></i>
                            <div className="mt-1 fs-18">Account not added</div>
                             <IconButton onClick={() => navigate("/driver_forms/account/add")} sx={{ backgroundColor: "#92c323", m: 0, px: 3, color: "#FFF", width: "fit-content", borderRadius: 2, '&:hover': { backgroundColor: "#76a521" } }} variant="contained" size="icon" className=""   >
                        <i class="ri-add-circle-line"></i>
                      </IconButton>
                          </div>
                        ) : (
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item d-none d-xl-block "  >
                              <div className="row" >
                                <div className="col-3  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  First Name
                                </div>
                                <div className="col-3  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.first_name}</span>
                                </div>
                                <div className="col-3  text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  Last Name
                                </div>
                                <div className="col-3  text-end text-muted " style={{ fontSize: 12 }}>
                                  <span className="fs-14" > {accountData?.last_name}</span>
                                </div>
                              </div>

                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  First Name
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.first_name}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Last Name
                                </div>
                                <div className="col-6 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.last_name}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-none d-xl-block"  >
                              <div className="row" >
                                <div className="col-2 col-md-2 col-lg-1 text-start" style={{ fontSize: 12, fontWeight: 600 }}>
                                  Email
                                </div>
                                <div className="col-4 col-md-4 col-lg-5 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.email}</span>
                                </div>
                                <div className="col-3 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  Phone
                                </div>
                                <div className="col-3 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.phone}</span>
                                </div>
                              </div>

                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row g-0 " >
                                <div className="col-2  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Email
                                </div>
                                <div className="col-10  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.email}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Phone
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.phone}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-none d-xl-block"  >
                              <div className="row" >
                                <div className="col-3 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  Bank Name
                                </div>
                                <div className="col-3 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.bank_name}</span>
                                </div>
                                <div className="col-3 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  Account Number
                                </div>
                                <div className="col-3 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.account_number}</span>
                                </div>
                              </div>

                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Bank Name
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.bank_name}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Account Number
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.account_number}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-none d-xl-block"  >
                              <div className="row" >
                                <div className="col-4 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  Routing Number
                                </div>
                                <div className="col-2 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.routing_number}</span>
                                </div>
                                <div className="col-4 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  Social Security Number
                                </div>
                                <div className="col-2 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.ssn_number}</span>
                                </div>
                              </div>

                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Routing Number
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.routing_number}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Social Security Number
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.ssn_number}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item  d-none d-xl-block"  >
                              <div className="row" >
                                <div className="col-2 text-start" style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Date Of Birth
                                </div>
                                <div className="col-4 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {formatDate(accountData?.dob)}</span>
                                </div>
                                <div className="col-2 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  Address
                                </div>
                                <div className="col-4 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.address}</span>
                                </div>
                              </div>

                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Date Of Birth
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {formatDate(accountData?.dob)}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Address
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.address}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-none d-xl-block"  >
                              <div className="row" >
                                <div className="col-2 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  City
                                </div>
                                <div className="col-4 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.city}</span>
                                </div>
                                <div className="col-2 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  State
                                </div>
                                <div className="col-4 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.state}</span>
                                </div>
                              </div>

                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  City
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.city}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  State
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.state}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-none d-xl-block"  >
                              <div className="row" >
                                <div className="col-2 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  Zip Code
                                </div>
                                <div className="col-4 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.postal_code}</span>
                                </div>
                                <div className="col-2 text-start" style={{ fontSize: 12, fontWeight: 600 }} >
                                  MCC
                                </div>
                                <div className="col-4 text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.business_profile_mcc}</span>
                                </div>
                              </div>

                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  Zip Code
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.postal_code}</span>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item d-lg-block d-xl-none ">
                              <div className="row" >
                                <div className="col-6  text-start  " style={{ fontSize: 12, fontWeight: 600 }}  >
                                  MCC
                                </div>
                                <div className="col-6  text-end text-muted " style={{ fontSize: 12 }} >
                                  <span className="fs-14" > {accountData?.business_profile_mcc}</span>
                                </div>
                              </div>
                            </li>
                          </ul>
                        )}
                         {Object.keys(accountData).length !== 0 && (
                          <div className="d-flex justify-content-between mx-3 " >
                          <Button f  variant="contained" sx={{ px: 2, my: 2, backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} >Edit</Button>
                          <Button f  variant="contained" sx={{ px: 2, my: 2, backgroundColor: "red", '&:hover': { backgroundColor: "red" } }} >Delete</Button>
                          </div>
                        )}
                      </Card>
                    </>
                  )}

                  {/* Card Info View */}
                  {selectedOption === 3 && (
                    <>
                     <IconButton onClick={() => toggleTab(0)} sx={{ backgroundColor: "#92c323", m: 0, px: 3, color: "#FFF", width: "fit-content", borderRadius: 2, '&:hover': { backgroundColor: "#76a521" } }} variant="contained" size="icon" className=""   >
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </IconButton>
                      <h5 className="mb-1 mt-4">Card Info</h5>
                      <Card className="p-4 border shadow-none mb-0 mt-4">
                        <div className="text-center text-muted">
                          <i
                            className="ri-bank-card-fill"
                            style={{ fontSize: "8rem", color: "gray" }}
                          ></i>
                          <div className="fs-16 mt-2">No Card Linked</div>
                        </div>
                      </Card>
                    </>
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PaymentComponent;
